import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  // Observable that components can subscribe to
  public loading$: Observable<boolean> = this.loadingSubject.asObservable();

  // Method to show the loading overlay
  show(): void {
    this.loadingSubject.next(true);
  }

  // Method to hide the loading overlay
  hide(): void {
    this.loadingSubject.next(false);
  }
}
